module.exports = __webpack_public_path__ + "media/slide3/contractMediaSlide3Part1vs-f5b787ef.png";